
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M441 144.225v347.171C441 502.78 431.801 512 420.444 512H91.556C80.199 512 71 502.78 71 491.396V20.604C71 9.22 80.199 0 91.556 0h205.556z","fill":"#2196f3"}}),_c('path',{attrs:{"d":"M410.167 113.32v378.076c0 11.383-9.199 20.604-20.556 20.604h30.833c11.357 0 20.556-9.22 20.556-20.604V144.225z","fill":"#1e88e5"}}),_c('path',{attrs:{"d":"M441 144.225H317.667c-11.353 0-20.556-9.225-20.556-20.604V0z","fill":"#90caf9"}}),_c('g',{attrs:{"fill":"#fafafa"}},[_c('path',{attrs:{"d":"M356.443 249.819H155.557c-8.534 0-15.453-6.918-15.453-15.453 0-8.534 6.918-15.453 15.453-15.453h200.885c8.534 0 15.453 6.918 15.453 15.453 0 8.534-6.918 15.453-15.452 15.453zM356.443 311.63H155.557c-8.534 0-15.453-6.918-15.453-15.453 0-8.534 6.918-15.453 15.453-15.453h200.885c8.534 0 15.453 6.918 15.453 15.453 0 8.534-6.918 15.453-15.452 15.453zM356.443 373.441H155.557c-8.534 0-15.453-6.918-15.453-15.453 0-8.534 6.918-15.453 15.453-15.453h200.885c8.534 0 15.453 6.918 15.453 15.453 0 8.534-6.918 15.453-15.452 15.453zM269.907 435.251h-114.35c-8.534 0-15.453-6.918-15.453-15.453 0-8.534 6.918-15.453 15.453-15.453h114.35c8.534 0 15.453 6.918 15.453 15.453s-6.918 15.453-15.453 15.453z"}})])])
          )
        }
      }
    